import { gql } from "@apollo/client";

export const CREATE_ORDER_AHEAD_ITEM = gql`
  mutation CreateOrderAheadItem($input: items_order_ahead_insert_input!) {
    insert_items_order_ahead_one(object: $input) {
      id
    }
  }
`;

export const UPDATE_ORDER_AHEAD_ITEM = gql`
  mutation UpdateOrderAheadItem($input: items_order_ahead_set_input, $where: items_order_ahead_bool_exp!) {
    update_items_order_ahead(_set: $input, where: $where) {
      returning {
        id
      }
    }
  }
`;

export const DELETE_ORDER_AHEAD_ITEM = gql`
   mutation DeleteOrderAheadItem($id: Int!) {
    delete_items_order_ahead_by_pk(id: $id) {
      id
    }
  }
`;
